/**
 * Learn hub routes use the `learn` segment in both English and Spanish.
 * CMS Spanish twins mirror the English path (`/es/learn/...`).
 * Editorial SEO pages may still live under `/es/aprende/...` and are served
 * via the catch-all WP route or static redirects.
 * Catalog course routes under `/learn/{category}/{course}` keep the `learn` segment.
 */
export const LEARN_HUB_PATHNAME = "/learn" as const;
export const LEARN_HUB_CATEGORY_PATHNAME = "/learn/[category]" as const;

export const LEARN_HUB_EN_SEGMENT = "learn";

export function resolveLearnHubWordpressPath(
  _locale: string | undefined,
  segments: string[],
): string {
  return segments.join("/");
}

/**
 * Previously redirected `/es/learn` → `/es/aprende`. That rewrite fought the
 * CMS twin layout (`/es/learn/...`) and the language selector, so it is a no-op.
 * Static redirects (e.g. `/es/learn/ai` → `/es/aprende/inteligencia-artificial`)
 * still run earlier in middleware via the redirect service.
 */
export function resolveLegacySpanishLearnHubRedirect(
  _pathname: string,
): string | null {
  return null;
}
